import React from 'react';
import styled from 'styled-components';
import opImg1 from '../../Asset/img/design.jpg';
import opImg2 from '../../Asset/img/software_engineer.svg';
import opImg3 from '../../Asset/img/social.png';
import opImg4 from '../../Asset/img/solu.jpg';
const CareerOp = () => {
  return (
    <CareerOpWrapper>
      <article className="op-box">
        <div className="op-it">
          <div className="imgBox">
            <img src={opImg1} alt="" />
          </div>
          <div className="meta">
            <h1>Product Designing</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut
              reiciendis fugiat doloribus mollitia. Dolore recusandae quasi
              minima, magnam sapiente accusamus?
            </p>
          </div>
          <div className="op-btn">View Opinion</div>
        </div>
        <div className="op-it">
          <div className="imgBox">
            <img src={opImg2} alt="" />
          </div>
          <div className="meta">
            <h1>Product Development</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut
              reiciendis fugiat doloribus mollitia. Dolore recusandae quasi
              minima, magnam sapiente accusamus?
            </p>
          </div>
          <div className="op-btn">View Opinion</div>
        </div>
        <div className="op-it">
          <div className="imgBox">
            <img src={opImg3} alt="" />
          </div>
          <div className="meta">
            <h1>Marketing</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut
              reiciendis fugiat doloribus mollitia. Dolore recusandae quasi
              minima, magnam sapiente accusamus?
            </p>
          </div>
          <div className="op-btn">View Opinion</div>
        </div>
        <div className="op-it">
          <div className="imgBox">
            <img src={opImg4} alt="" />
          </div>
          <div className="meta">
            <h1>IT SOLUTION</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut
              reiciendis fugiat doloribus mollitia. Dolore recusandae quasi
              minima, magnam sapiente accusamus?
            </p>
          </div>
          <div className="op-btn">View Opinion</div>
        </div>
      </article>
    </CareerOpWrapper>
  );
};

const CareerOpWrapper = styled.section`
  min-height: 80vh;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  .op-box {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 1.2rem;
    width: 98%;
    margin: 0 auto;
    .op-it {
      background: #fff;
      border-radius: 0.2rem;
      box-shadow: 0 0.5rem 1rem rgba(4, 4, 59, 0.137);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 1rem;
      height: 400px;
      width: 300px;

      .imgBox {
        background: #fff;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 70%;
        height: 150px;
        margin: 0 auto;
        transform: translateY(-2rem);
        img {
          width: 90%;
        }
      }

      .meta {
        h1 {
          color: var(--bg-color);
          font-size: 1.2rem;
          font-weight: 700;
          text-transform: uppercase;
          text-align: center;
        }
        p {
          text-align: center;
          font-size: 14px;
          line-height: 1.7;
          padding: 10px 2px;
        }
      }
      .op-btn{
        font-weight: 700;
        background: linear-gradient(to left top, var(--ico-color),var(--bg-color));
        border-radius: 50px;
        box-shadow: 0 .5rem 1rem var(--bga-color);
        color: #fff;
        cursor: pointer;
        padding: 10px;
        text-align: center;
        width: 60%;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .op-box{
      grid-template-columns: repeat(2, 1fr);
      gap: 1.5rem;
      .op-it{
        width: 100%;
        height: 380px;
        margin-bottom: 10px;
        .imgBox{
          width: 50%;
          transform: translateY(0);
        }
      }
    }
  }

  @media screen and (max-width: 430px) {
    .op-box{
      grid-template-columns: repeat(1, 1fr);
      .op-it{
        width: 100%;
        height: 380px;
        margin-bottom: 10px;
        .imgBox{
          width: 50%;
          transform: translateY(0);
        }
      }
    }
  }
`;
export default CareerOp;
